"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

require("isomorphic-fetch");

var _xhruploadHelper = _interopRequireDefault(require("./xhrupload-helper"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * SignedUrlHelper - Upload files to Google storage directly
 *
 * The flow:
 * - requesting a signed url from Google with specifics about the file. The response will yield an url (and a image_id) which you can use to upload a binary file to.
 * - We request a sessionUrl base on the signed url response
 * - We upload the file to the sessionUrl
 * - After that we send the image_id (retrieved in the first step) to our own service to link the location to the image just uploaded
 *
 * param Files - Array of files [File, File, File] (note: actually File files)
 * param token - Xrsf token from you auth
 * param storageEndpoint - is the storage url taken from the runtimeConfig
 * param queryData - Optional array of object to append to the request for a signedUrl as
 *                   query params i.e: ?siteId=[siteId]. Example:
 * [
    {
      key: 'siteId',
      value: <siteId>
    }
  ]
 *
 * param progressCallback - Progress function we send progress (and eventually the full return object) events
 * param options - Object of options
 *    multipleAtOnce (boolean) - Multiple signed urls and callbacks at ones,
 *                      useful when your server has a 5 requests per 5
 *                      seconds limit
 *
 * Example usage:
 * const signedFileUpload = new SignedUrlHelper(
 *    filesToUpload,
 *    token,
 *    storageEndpoint,
 *    tags,
 *    (progress, index) => {
 *      console.log(progress, index)
 *    },
 *    (error, index) => {
 *      console.log(error, index)
 *    },
 *    {
 *        multipleAtOnce: true
 *    }
 * )
 * signedFileUpload.initialize()
 */
var SignedUrlHelper = function SignedUrlHelper(_files, token, _storageEndpoint, _queryData, progressCallback, errorCallback) {
  var _this = this;

  var _options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

  (0, _classCallCheck2["default"])(this, SignedUrlHelper);

  this.setEndpoints = function (isDocument, storageEndpoint, queryData) {
    if (isDocument) {
      _this.signedUrlEndpoint = "".concat(storageEndpoint, "/v1.0/Documents");
      _this.publishedDocumentEndpoint = _this.signedUrlEndpoint + '/published';
      _this.signedUrlEndpointCallback = "".concat(storageEndpoint, "/v1.0/Documents/publish");
    } else {
      var signedUrlAlias = _this.multipleAtOnce ? 'signed_urls' : 'signed_url';

      if (queryData) {
        var params = Object.keys(queryData).map(function (key) {
          return "".concat(key, "=").concat(queryData[key]);
        });
        _this.signedUrlEndpoint = "".concat(storageEndpoint, "/v1.0/images/").concat(signedUrlAlias, "?").concat(params.join('&'));
      } else {
        _this.signedUrlEndpoint = "".concat(storageEndpoint, "/v1.0/images/").concat(signedUrlAlias);
      }

      _this.signedUrlEndpointCallback = "".concat(storageEndpoint, "/v1.0/images/signed_url_callback");
    }
  };

  this.prepareFiles = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(file) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(resolve, reject) {
                  var _yield$_this$getImage, height, width, fileNameReplaced;

                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this.getImageDimensions(file);

                        case 2:
                          _yield$_this$getImage = _context.sent;
                          height = _yield$_this$getImage.height;
                          width = _yield$_this$getImage.width;
                          fileNameReplaced = _this.checkFileName(file);
                          resolve({
                            height: height,
                            width: width,
                            file: fileNameReplaced
                          });

                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2, _x3) {
                  return _ref2.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  this.mapPropertiesNeeded = function (file) {
    var properties = {
      file_name: file.name,
      content_type: file.type,
      content_length: file.size
    };

    if (_this.isDocument) {
      properties.asset_type = 3;
    }

    return properties;
  };

  this.getSignedUrls = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(files) {
      var propertiesMapped, options, signedUrl, jsonned;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              propertiesMapped = files.map(function (file) {
                var width = file.width,
                    height = file.height;
                return _objectSpread(_objectSpread({}, _this.mapPropertiesNeeded(file.file)), {}, {
                  'image_width': width,
                  'image_height': height
                });
              });
              options = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(_this.token)
                },
                credentials: 'include',
                body: JSON.stringify(propertiesMapped)
              };
              _context3.next = 4;
              return fetch(_this.signedUrlEndpoint, options);

            case 4:
              signedUrl = _context3.sent;
              _context3.next = 7;
              return signedUrl.json();

            case 7:
              jsonned = _context3.sent;
              return _context3.abrupt("return", jsonned);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.runAllCallbacks = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var imageIds, callBacks;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            imageIds = _this.imagesCompleted.map(function (img) {
              return img.imageId;
            });
            _context4.next = 3;
            return _this.postCallback(imageIds);

          case 3:
            callBacks = _context4.sent;
            callBacks.forEach(function (cb, index) {
              var savedObj = {};
              savedObj.callBackResponse = cb;

              _this.progressCallback(savedObj, index);
            });

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  this.initialize = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
    var mappedPromises, preparedFiles, signedUploadUrlsResponse;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!(_this.multipleAtOnce && !_this.isDocument)) {
              _context7.next = 13;
              break;
            }

            _context7.next = 3;
            return _this.files.map(function (file) {
              return _this.prepareFiles(file);
            });

          case 3:
            mappedPromises = _context7.sent;
            _context7.next = 6;
            return Promise.all(mappedPromises);

          case 6:
            preparedFiles = _context7.sent;
            _context7.next = 9;
            return _this.getSignedUrls(preparedFiles);

          case 9:
            signedUploadUrlsResponse = _context7.sent;
            signedUploadUrlsResponse.forEach( /*#__PURE__*/function () {
              var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(fileResponse, index) {
                var _fileResponse$signed_, signedUrl, contentHeaders, originalFilename, imageId, file, onResponse, onProgress, onError, sessionUrl, error, _error;

                return _regenerator["default"].wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        _fileResponse$signed_ = fileResponse.signed_url, signedUrl = _fileResponse$signed_.signed_url, contentHeaders = _fileResponse$signed_.content_headers, originalFilename = _fileResponse$signed_.original_filename, imageId = fileResponse.image_id;
                        file = preparedFiles.find(function (file) {
                          return file.file.name === originalFilename;
                        });
                        _context5.prev = 2;

                        onResponse = function onResponse(response, id) {
                          _this.imagesCompleted[index] = {
                            response: response,
                            imageId: imageId
                          };

                          var checkForEmpties = _this.imagesCompleted.filter(function (img) {
                            return img;
                          });

                          if (checkForEmpties.length === _this.files.length) {
                            _this.runAllCallbacks();
                          }
                        };

                        onProgress = function onProgress(response, id) {
                          _this.progressCallback(response, index);
                        };

                        onError = function onError(e) {
                          _this.errorCallback(e);
                        };

                        _context5.next = 8;
                        return _this.getSessionUrl(file.file, signedUrl, contentHeaders);

                      case 8:
                        sessionUrl = _context5.sent;

                        if (!sessionUrl) {
                          error = new Error("sessionUrl is null");

                          _this.errorCallback(error);
                        } else {
                          _this.uploadFile(sessionUrl, file.file, imageId, onResponse, onProgress, onError);
                        }

                        _context5.next = 16;
                        break;

                      case 12:
                        _context5.prev = 12;
                        _context5.t0 = _context5["catch"](2);
                        _error = new Error("sessionUrl: ".concat(_context5.t0));

                        _this.errorCallback(_error);

                      case 16:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, null, [[2, 12]]);
              }));

              return function (_x5, _x6) {
                return _ref6.apply(this, arguments);
              };
            }());
            _context7.next = 14;
            break;

          case 13:
            _this.files.forEach( /*#__PURE__*/function () {
              var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(file, index) {
                var fileNameReplaced, _ref8, height, width, _yield$_this$getSigne, _yield$_this$getSigne2, signedUrl, contentHeaders, originalFilename, fileNameFromResponse, imageId, fileName, onResponse, onProgress, onError, sessionUrl, error, _error2;

                return _regenerator["default"].wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        // we dont support weird characters
                        fileNameReplaced = _this.checkFileName(file);

                        if (!_this.isDocument) {
                          _context6.next = 5;
                          break;
                        }

                        _context6.t0 = {};
                        _context6.next = 8;
                        break;

                      case 5:
                        _context6.next = 7;
                        return _this.getImageDimensions(file);

                      case 7:
                        _context6.t0 = _context6.sent;

                      case 8:
                        _ref8 = _context6.t0;
                        height = _ref8.height;
                        width = _ref8.width;
                        _context6.next = 13;
                        return _this.getSignedUrl(fileNameReplaced, width, height);

                      case 13:
                        _yield$_this$getSigne = _context6.sent;
                        _yield$_this$getSigne2 = _yield$_this$getSigne.signed_url;
                        signedUrl = _yield$_this$getSigne2.signed_url;
                        contentHeaders = _yield$_this$getSigne2.content_headers;
                        originalFilename = _yield$_this$getSigne2.original_filename;
                        fileNameFromResponse = _yield$_this$getSigne2.file_name;
                        imageId = _yield$_this$getSigne.image_id;
                        fileName = _this.isDocument ? fileNameFromResponse : imageId;
                        _context6.prev = 21;

                        onResponse = function onResponse(response, id) {
                          _this.progressCallback(response, index, _this.isDocument ? null : {
                            height: height,
                            width: width
                          });
                        };

                        onProgress = function onProgress(response, id) {
                          _this.progressCallback(response, index);
                        };

                        onError = function onError(e) {
                          _this.errorCallback(e);
                        };

                        _context6.next = 27;
                        return _this.getSessionUrl(fileNameReplaced, signedUrl, contentHeaders);

                      case 27:
                        sessionUrl = _context6.sent;

                        if (!sessionUrl) {
                          error = new Error("sessionUrl is null");

                          _this.errorCallback(error);
                        } else {
                          _this.uploadFile(sessionUrl, file, fileName, onResponse, onProgress, onError);
                        }

                        _context6.next = 35;
                        break;

                      case 31:
                        _context6.prev = 31;
                        _context6.t1 = _context6["catch"](21);
                        _error2 = new Error("sessionUrl: ".concat(_context6.t1));

                        _this.errorCallback(_error2);

                      case 35:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6, null, [[21, 31]]);
              }));

              return function (_x7, _x8) {
                return _ref7.apply(this, arguments);
              };
            }());

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  this.checkFileName = function (file) {
    // rebuild the file with normalized file names
    var newFile = new window.File([file], encodeURI(file.name.replace(/[<>:"/\\|?*()]+/g, '').replace(/\s/g, '-')), {
      type: file.type
    });
    return newFile;
  };

  this.getSessionUrl = /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(file, url, headers) {
      var options, sessionResponse;
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              options = {
                headers: {
                  'x-goog-resumable': 'start',
                  'Content-Length': 0,
                  'Content-Type': file.type,
                  'x-goog-meta-x-builder-filename': file.name
                },
                method: 'POST',
                mode: 'cors'
              };
              _context8.next = 3;
              return fetch(url, options);

            case 3:
              sessionResponse = _context8.sent;
              return _context8.abrupt("return", sessionResponse.headers.get('location'));

            case 5:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x9, _x10, _x11) {
      return _ref9.apply(this, arguments);
    };
  }();

  this.getImageDimensions = function (file) {
    return new Promise(function (resolve, reject) {
      var tempImage = new window.Image();

      tempImage.onload = function () {
        resolve({
          width: tempImage.width,
          height: tempImage.height
        });
      };

      tempImage.src = window.URL.createObjectURL(file);
    });
  };

  this.getSignedUrl = /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(file, width, height, queryData) {
      var mappedFile, options, signedUrl, jsonned;
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              mappedFile = _this.mapPropertiesNeeded(file);

              if (width && height) {
                mappedFile.width = width;
                mappedFile.height = height;
              }

              options = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(_this.token)
                },
                credentials: 'include',
                body: JSON.stringify(_this.isDocument ? [mappedFile] : mappedFile)
              };
              _context9.next = 5;
              return fetch(_this.signedUrlEndpoint, options);

            case 5:
              signedUrl = _context9.sent;
              _context9.next = 8;
              return signedUrl.json();

            case 8:
              jsonned = _context9.sent;

              if (!_this.isDocument) {
                _context9.next = 13;
                break;
              }

              return _context9.abrupt("return", {
                signed_url: jsonned[0]
              });

            case 13:
              return _context9.abrupt("return", jsonned);

            case 14:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x12, _x13, _x14, _x15) {
      return _ref10.apply(this, arguments);
    };
  }();

  this.getResponseEndpoint = function (ids, options) {
    if (_this.isDocument) {
      return _this.signedUrlEndpointCallback + '/' + ids;
    } else {
      var typeAlias = Array.isArray(ids) ? 'image_ids' : 'image_id';
      options.body = JSON.stringify((0, _defineProperty2["default"])({}, typeAlias, ids));
      return _this.signedUrlEndpointCallback;
    }
  };

  this.postCallback = /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(ids) {
      var options, endpoint, response, responseJson;
      return _regenerator["default"].wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              options = {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(_this.token)
                },
                credentials: 'include'
              };
              endpoint = _this.getResponseEndpoint(ids, options);
              _context10.next = 4;
              return fetch(endpoint, options);

            case 4:
              response = _context10.sent;

              if (!_this.isDocument) {
                _context10.next = 9;
                break;
              }

              return _context10.abrupt("return", null);

            case 9:
              _context10.next = 11;
              return response.json();

            case 11:
              responseJson = _context10.sent;
              return _context10.abrupt("return", responseJson);

            case 13:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x16) {
      return _ref11.apply(this, arguments);
    };
  }();

  this.getLastUploadedFile = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
    var options, endpoint, documents;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            options = {
              method: 'GET',
              headers: {
                Authorization: "Bearer ".concat(_this.token)
              },
              credentials: 'include'
            };
            endpoint = _this.publishedDocumentEndpoint;
            _context11.next = 4;
            return fetch(endpoint, options);

          case 4:
            documents = _context11.sent;
            return _context11.abrupt("return", documents.json());

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  this.uploadFile = function (url, file, imageId, onResponse, onProgress, onError) {
    var upload = new _xhruploadHelper["default"]({
      url: url,
      files: [file],
      sendAsBinary: true,
      method: 'PUT'
    }); // when its done!

    upload.response = /*#__PURE__*/function () {
      var _ref13 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(response, id) {
        var savedObj, callBackResponse;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                savedObj = {
                  filename: file.name,
                  internal_filename: file.name,
                  content_type: file.type,
                  content_length: file.size,
                  file_status: 1
                }; // if we are doing multiple callback at once, we have to return an empty object first
                // witht the empty image_url. We supply that later when all callback are posted at once

                callBackResponse = {
                  image_url: ''
                };

                if (_this.multipleAtOnce) {
                  _context12.next = 6;
                  break;
                }

                _context12.next = 5;
                return _this.postCallback(imageId);

              case 5:
                callBackResponse = _context12.sent;

              case 6:
                if (!_this.isDocument) {
                  _context12.next = 12;
                  break;
                }

                _context12.next = 9;
                return _this.getLastUploadedFile();

              case 9:
                savedObj.callBackResponse = _context12.sent;
                _context12.next = 13;
                break;

              case 12:
                savedObj.callBackResponse = callBackResponse;

              case 13:
                savedObj.response = response;
                onResponse(savedObj);

              case 15:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x17, _x18) {
        return _ref13.apply(this, arguments);
      };
    }(); // progress event from xhrupload


    upload.progress = function (progress, id) {
      onProgress(progress, id);
    };

    upload.error = function (e) {
      onError(e);
    };

    upload.start();
  };

  this.fileToBinary = function (file) {
    return new Promise(function (resolve, reject) {
      var reader = new window.FileReader();

      reader.onload = function () {
        resolve(reader.result);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  if (!_files || !_storageEndpoint || !token) {
    throw new Error('Please supply the correct arguments');
  }

  this.files = _files;
  this.token = token;
  this.imagesCompleted = [];
  this.options = _options;
  this.multipleAtOnce = _options && _options.multipleAtOnce;
  this.isDocument = _options && _options.isDocument;
  this.progressCallback = progressCallback;
  this.errorCallback = errorCallback;
  this.setEndpoints(this.isDocument, _storageEndpoint, _queryData);
};

var _default = SignedUrlHelper;
exports["default"] = _default;